const SKIP_PREFIXES = ['blob:', 'data:', 'javascript:'];

const MEDIA_URL_KEYS = [
	'url',
	'thumbUrl',
	'originUrl',
	'videoUrl',
	'coverUrl',
	'headImage',
	'headImageThumb',
];

/** webpack 打包的本地静态资源，如 /img/new_friend.png（无日期目录） */
export function isLocalStaticAsset(path) {
	const normalized = path && path.startsWith('/') ? path : `/${path || ''}`;
	return /^\/(img|assets|static)\/[^/]+\.(png|jpe?g|gif|webp|svg|ico)(\?.*)?$/i.test(normalized);
}

/**
 * 是否已可安全作为 img src（避免相对媒体路径在 s3Url 未就绪时误请求本地域名）
 */
export function isDisplayableMediaUrl(url, s3Url) {
	if (url === undefined || url === null) return false;
	if (typeof url !== 'string') return false;
	const trimmed = url.trim();
	if (!trimmed) return false;
	if (SKIP_PREFIXES.some((prefix) => trimmed.startsWith(prefix))) {
		return true;
	}
	if (/^https?:\/\//i.test(trimmed) || trimmed.includes('://')) {
		return true;
	}
	const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
	if (trimmed.includes('assets/') || isLocalStaticAsset(path)) {
		return true;
	}
	// 其余相对路径依赖 s3 域名拼接后再展示
	return !!(s3Url && String(s3Url).trim());
}

/**
 * 将 objectKey 或完整 URL 规范为相对路径（以 / 开头）
 */
export function normalizeMediaPath(pathOrUrl) {
	if (pathOrUrl === undefined || pathOrUrl === null) return pathOrUrl;
	if (typeof pathOrUrl !== 'string') return pathOrUrl;
	const trimmed = pathOrUrl.trim();
	if (!trimmed) return trimmed;
	if (SKIP_PREFIXES.some((prefix) => trimmed.startsWith(prefix))) {
		return trimmed;
	}
	if (trimmed.includes('http')) {
		try {
			return new URL(trimmed).pathname || trimmed;
		} catch (e) {
			return trimmed;
		}
	}
	return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export function resolveMediaUrl(url, s3Url) {
	if (url === undefined || url === null) return url;
	if (typeof url !== 'string') return url;
	const trimmed = url.trim();
	if (!trimmed) return trimmed;
	if (SKIP_PREFIXES.some((prefix) => trimmed.startsWith(prefix))) {
		return trimmed;
	}
	// 已是完整 http(s) URL，不做替换
	if (trimmed.includes('http')) {
		return trimmed;
	}
	// 本地静态资源（webpack 打包），保持原样
	const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
	if (trimmed.includes('assets/') || isLocalStaticAsset(path)) {
		return trimmed;
	}
	if (!s3Url || typeof s3Url !== 'string') return trimmed;

	const base = s3Url.trim().replace(/\/$/, '');
	if (!base) return trimmed;

	const targetBase = base.includes('://') ? base : `https://${base}`;
	return `${targetBase}${path}`;
}

export function resolveMediaUrlList(urls, s3Url) {
	if (!Array.isArray(urls)) return urls;
	return urls.map((url) => resolveMediaUrl(url, s3Url));
}

export function resolveMediaUrlsInObject(obj, s3Url) {
	if (!obj || typeof obj !== 'object') return obj;
	if (Array.isArray(obj)) {
		return obj.map((item) => resolveMediaUrlsInObject(item, s3Url));
	}
	const result = { ...obj };
	MEDIA_URL_KEYS.forEach((key) => {
		if (typeof result[key] === 'string') {
			result[key] = resolveMediaUrl(result[key], s3Url);
		}
	});
	return result;
}
